<template>
    <div class="dialog-search-info-customer">
        <div class="filter-bar">
            <el-row :gutter="12">
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <el-input
                        v-model="form.keyword"
                        placeholder="Nhập mã, tên khách hàng"
                        prefix-icon="el-icon-search"
                        class="mt-2"
                        clearable
                        @input="onSearchInput"
                    />
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <el-input
                        v-model="form.phone"
                        type="number"
                        placeholder="Nhập số điện thoại khách hàng"
                        prefix-icon="el-icon-phone"
                        clearable
                        class="mt-2"

                        @input="onSearchInput"
                    />
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <el-select
                        v-if="[7,6].includes(keyAccount)"
                        v-model="form.area_id"
                        placeholder="Chọn Khu vực"
                        filterable
                        collapse-tags
                        class="mt-2"
                        clearable
                        @change="getCustomerSupport(); getCenter()"
                        style="width: 100%;"
                    >
                        <el-option
                            v-for="item in areas"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <el-select
                        v-if="[5,6,7].includes(keyAccount)"
                        v-model="form.branch_id"
                        placeholder="Chọn văn phòng"
                        class="mt-2"
                        filterable
                        clearable
                        @change="getCustomerSupport(); getChildUser(form.branch_id)"
                        style="width: 100%;"
                    >
                        <el-option
                            v-for="item in branches"
                            :key="item.id"
                            :label="item.name_alias || item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <tree-select
                        v-model="cache_sale"
                        :normalizer="normalizer"
                        :options="options"
                        :show-count="true"
                        class="mt-2"
                        placeholder="Chọn nhân sự muốn xem..."
                        search-nested
                        style="width: 100%;"
                        @input="handleChangeSale"
                    >
                        <!--eslint-disable-->
                        <label
                            slot="option-label"
                            slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                            :class="labelClassName"
                        >
                            <img :src="publicPath + getImageHierarchy(node.raw.profile.account_type.id)" alt="">
                            <span> {{ node.label }} -  {{ node.raw.id + 100000 }}</span>
                            <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                        </label>
                    </tree-select>
                </el-col>
            </el-row>
        </div>

        <!-- Bảng dữ liệu -->
        <el-table
            :data="tableData"
            style="width: 100%"
            v-loading="loading"
            element-loading-text="Đang tải dữ liệu..."
            :empty-text="!loading ? 'Không có dữ liệu' : ''"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55px" />

            <el-table-column prop="customer_id" label="Mã Khách hàng" min-width="120px"/>
            <el-table-column prop="name" label="Tên Khách hàng" min-width="130px"/>
            <el-table-column prop="contract_id" label="Mã hợp đồng" min-width="110px"/>
            <el-table-column prop="phone" label="Số điện thoại" min-width="110px"/>
            <el-table-column prop="date" label="Buổi kết thúc khóa" min-width="150px"/>
            <el-table-column prop="course_name" label="Khóa học cuối" min-width="200px"/>
            <el-table-column label="Trạng thái" min-width="120px">
                <template v-slot="scope">
                    <el-button
                        :type="scope.row.is_send ? 'success' : 'danger'"
                    size="small"
                    >
                        {{scope.row.is_send ? 'Đã gửi' : 'Chưa gửi'}}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="Hành động" width="120" class="text-center">
                <template v-slot="scope">
                    <button
                        @click="changePage(scope.row)"
                        class="btn btn-info btn-sm btn-icon waves-effect waves-themed mr-2"
                    >
                        <i class="fa fa-eye"></i>
                    </button>
                </template>
            </el-table-column>
        </el-table>

        <!-- Phân trang -->
        <div class="mt-3" style="display:flex; justify-content:center;">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page.sync="paging.current_page"
                :page-size="paging.per_page"
                layout="prev, pager, next"
                :total="paging.total"
            />
        </div>

        <!-- Footer: thông tin số lượng chọn + nút gửi -->
        <div class="d-flex justify-content-end align-items-center mt-2" style="gap: 12px;">
            <span v-if="selectedCustomers.length">
                Đã chọn <b>{{ selectedCustomers.length }}</b> khách hàng
            </span>
            <el-button
                type="primary"
                size="medium"
                class="el-icon-message"
                :disabled="!selectedCustomers.length"
                @click="handleSendPromotion"
            >
                Gửi mail
            </el-button>
        </div>

        <!-- Dialog gửi khuyến mãi -->
        <el-dialog
            title="Gửi khuyến mãi cho khách hàng cuối khóa"
            append-to-body
            :visible.sync="dialogSendPromotion"
        >
            <div>
            </div>
            <div class="mt-5">
                <label>Tải ảnh khuyễn mãi:</label> <span class="text-danger">*</span>
                <div
                    class="d-flex w-100"
                    style="gap: 10px; display: flex; flex-wrap: wrap; margin-top: 10px;"
                >
                    <el-upload
                        action="#"
                        class="w-100 el-upload-css"
                        list-type="picture-card"
                        :auto-upload="false"
                        :file-list="promotion.files"
                        :on-change="onFileChange"
                        :on-remove="handleRemove"
                        :on-preview="handlePictureCardPreview"
                        accept="image/*,video/*"
                        :limit="8"
                    >
                        <i slot="default" class="el-icon-upload2"></i>

                        <div slot="file" slot-scope="{ file }" class="uploader-item">
                            <video
                                v-if="/^video/.test(file.raw?.type) || file.isVideo"
                                :src="file.url"
                                muted
                                playsinline
                            ></video>
                            <img
                                v-else
                                class="el-upload-list__item-thumbnail"
                                :src="file.url"
                                alt=""
                            >
                            <span class="el-upload-list__item-actions">
                                <span
                                    class="el-upload-list__item-preview"
                                    @click="handlePictureCardPreview(file)"
                                >
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span
                                    class="el-upload-list__item-delete"
                                    @click="handleRemove(file)"
                                >
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogSendPromotion = false">Hủy</el-button>
                <el-button type="primary" :loading="sending" @click="sendMail">
                    Gửi Mail
                </el-button>
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="dialogVisible"
            append-to-body
            top="10vh"
            :show-close="false"
            custom-class="dialog-image-full"
        >
            <img :src="dialogImageUrl" alt="" class="dialog-image">
        </el-dialog>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'
import { GET_CUSTOMER_SUPPORT, SEND_PROMOTION_EMAIL } from '@/core/services/store/customer/customer.module'
import {BRANCH_LIST, GET_CHILD_USER} from "../../../core/services/store/service.module";
import {GET_REGIONS_BY_USER} from "../../../core/services/store/customer/customer.module";

export default {
    name: 'DialogSearchInfoCustomer',
    data() {
        return {
            publicPath: process.env.VUE_APP_BASE_URL,
            form: {
                keyword: '',
                phone: '',
                sale: '',
                area_id: '',
                branch_id: '',
            },
            tableData: [],
            areas: [],
            branches: [],
            loading: false,
            paging: {
                current_page: 1,
                per_page: 5,
                total: 0,
            },
            debouncedSearch: null,
            dialogSendPromotion: false,
            promotion: {
                files: [],
            },
            dialogVisible: false,
            dialogImageUrl: '',
            sending: false,

            selectedCustomers: [],
            imageHierarchy: {
                '5': 'media/hierarchy/gdvp.png',
                '1': 'media/hierarchy/sl.png',
                '2': 'media/hierarchy/se.png',
                '3': 'media/hierarchy/s.png',
                '4': 'media/hierarchy/si.png'
            },
            cache_sale: null,
            options: [],
        }
    },
    props: {
        is_show: { type: Boolean, default: false },
    },
    watch: {
        is_show: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.getCustomerSupport();
                    this.getChildUser();
                    this.getCenter();
                    this.getRegions();
                } else {
                    this.tableData = []
                    this.form.keyword = ''
                    this.form.phone = ''
                    this.paging.current_page = 1
                    this.selectedCustomers = []
                }
            },
        },
    },

    created() {
        this.debouncedSearch = debounce(this.getCustomerSupport, 400)
    },
    methods: {
        getCustomerSupport() {
            this.loading = true
            const payload = {
                ...this.form,
                page: this.paging.current_page,
            }
            this.$store
                .dispatch(GET_CUSTOMER_SUPPORT, payload)
                .then((res) => {
                    if (res.status === 422) {
                        this.$message({
                            type: 'warning',
                            message: `${res.message}`,
                            showClose: true,
                        })
                        return
                    }
                    this.tableData = res.data.items || []
                    this.paging.per_page = Number(res.data.pagination?.per_page ?? 25)
                    this.paging.current_page = Number(res.data.pagination?.current_page ?? 1)
                    this.paging.total = res.data.pagination.has_more
                        ? this.paging.current_page * this.paging.per_page + 1
                        : this.paging.current_page * this.paging.per_page

                    this.selectedCustomers = []
                    this.loading = false;
                }).catch((err) => {
                    this.loading = false;
                    this.$message({
                        type: 'error',
                        message: err.message || 'Có lỗi xảy ra khi tải dữ liệu.',
                        showClose: true,
                        })
                })
        },

        onSearchInput() {
            this.paging.current_page = 1
            this.debouncedSearch()
        },

        handleCurrentChange(page) {
            this.paging.current_page = page
            this.getCustomerSupport()
        },

        handleChangeSale() {
            this.form.sale = this.cache_sale;
            if(!this.form.sale) {
                this.form.view_as = '';
            }
            this.getCustomerSupport();
        },

        handleSelectionChange(selection) {
            this.selectedCustomers = selection
        },

        handleSendPromotion() {
            if (!this.selectedCustomers.length) {
                this.$message.warning('Vui lòng chọn ít nhất 1 khách hàng trong bảng.')
                return
            }

            this.promotion.files = []
            this.dialogSendPromotion = true
        },

        onFileChange(file, fileList) {
            if (!file.url && file.raw) file.url = URL.createObjectURL(file.raw)
            file.isVideo = /^video/.test(file.raw?.type)
            this.promotion.files = fileList
        },

        handleRemove(file) {
            this.promotion.files = this.promotion.files.filter((f) => f.uid !== file.uid)
        },

        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },

        changePage(item) {
            const contractId = item?.customer_id - 100000;
            const customerId = item?.id

            const path = `/customer/view/${contractId}`
            const url = `${path}?customer_id=${customerId}`

            if (this.$router && typeof this.$router.push === 'function') {
                this.$router.push({ path, query: { customer_id: customerId } })
            } else {
                window.location.href = url
            }
        },

        async sendMail() {
            if (!this.selectedCustomers.length) {
                this.$message.error('Thiếu thông tin khách hàng (chưa chọn khách nào).')
                return
            }
            if (!this.promotion.files.length) {
                this.$message.error('Vui lòng chọn ít nhất 1 ảnh/video.')
                return
            }

            this.sending = true
            try {
                for (const customer of this.selectedCustomers) {
                    const fd = new FormData()
                    fd.append('customer_id', customer.id)
                    fd.append('contract_id', customer.contract_id || '')
                    fd.append('subject', 'Khuyến mãi cuối khóa')
                    fd.append('end_date', customer.date)

                    this.promotion.files.forEach((f) => {
                        if (f.raw) {
                            fd.append('fileList[]', f.raw, f.raw.name)
                        } else if (f.url) {
                            fd.append('file_urls[]', f.url)
                        }
                    })
                    const res = await this.$store.dispatch(SEND_PROMOTION_EMAIL, fd)
                    console.log('res?.data', res?.data);

                    if (res.error) {
                        this.$message({
                            type: 'warning',
                            message: res?.data.detail || 'Gửi mail thất bại cho 1 khách hàng.',
                            showClose: true,
                        })

                        this.close();
                        this.dialogSendPromotion = false
                        return;
                    }

                    let customer_id = res?.data.customer_id ?? '';
                    this.tableData = this.tableData.map(item => {
                        if (item.id === customer_id) {
                            return {
                                ...item,
                                is_send: 1,
                            };
                        }
                        return item;
                    });

                }

                this.$message.success('Đã gửi mail khuyến mãi cho các khách hàng đã chọn.')


                this.dialogSendPromotion = false
                this.selectedCustomers = []
            } catch (e) {
                this.$message.error('Có lỗi khi gửi mail.')
            } finally {
                this.sending = false
            }
        },

        getChildUser() {
            var branchId = '';
            if([1,5].includes(this.currentUser.account_type.id)){
                branchId = this.currentUser.profile.chi_nhanh_id;
            };
            const payload = {
                branch_id: this.form.branch_id || branchId,
            };
            this.$store.dispatch(GET_CHILD_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.childUsers = response.data;
                        this.options = response.data;
                    }
                });
        },

        getCenter() {
            const payload = {
                area_id: this.form.area_id
            };

            this.$store.dispatch(BRANCH_LIST,payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.branches = response.data;
                    }
                })

        },

        getRegions() {
            const payload = {
                all: this.keyAccount === 7 ? 1 : 0
            };
            this.$store.dispatch(GET_REGIONS_BY_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.areas = response.data;
                    }
                })
        },

        normalizer: function (node) {
            return {
                id: node.id,
                label: node.name,
            }
        },

        close() {
               this.$emit('close');
        },

        getImageHierarchy(account_type) {
            return this.imageHierarchy[account_type];
        },
    },
    computed: {
        ...mapGetters(['currentUser', 'keyAccount']),
    },
}
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}

.el-upload-css {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: flex-start;
    width: 100%;
}

/* Làm phẳng <ul> để các <li> “bước ra” thành item của flex container */
.el-upload-css .el-upload-list--picture-card {
    display: contents;
}

.el-upload-css .el-upload-list__item {
    width: 200px !important;
    height: 150px !important;
    margin: 0 !important; /* đã có gap ở wrapper */
}

.el-upload-css .el-upload--picture-card {
    width: 200px !important;
    height: 150px !important;
    line-height: 150px !important;
    order: 9999; /* đẩy xuống cuối */
}

.dialog-image-full .el-dialog__body {
    padding: 0;

}

.dialog-image-full .el-dialog__header {
    display: none;
}

.dialog-image {
    display: block;
    width: 100%;
    height: auto;
}

.dialog-search-info-customer .el-table-column--selection .cell {
    padding-left: 10px;
}
</style>
